export default "__VITE_PUBLIC_ASSET__d4767056__"